import Icon from '@ant-design/icons';
import React from 'react';

const ResourcesSvg = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.53 3.853a3.001 3.001 0 00-5.697 1.315v9.001h1.715M1.833 8.168h1.715M1.833 5.596h4.715"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.835 9.454v4.715H5.264V9.454"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.405 10.311l4.538-4.537a.857.857 0 011.213 0l4.537 4.537M9.55 7.954c.117 0 .213.096.213.214M9.335 8.168c0-.118.096-.214.214-.214M9.549 8.382a.214.214 0 01-.214-.214M9.763 8.168a.214.214 0 01-.214.214"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M11.264 10.74h-3.43a.857.857 0 00-.857.857v2.572h5.144v-2.572a.857.857 0 00-.857-.857z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ResourcesIcon = (props: any) => (
  <Icon component={ResourcesSvg} {...props} />
);

export default ResourcesIcon;
